import {withRouter} from 'react-router';

import {withApollo} from 'react-apollo';
import {EventReportIncidentForm} from '@modules/events/forms/EventReportIncidentForm';
import {convertSecondsToMinutesWithOneDecimal, convertToInt} from '@utils/helpers';
import {refetchQueryByName} from '@utils/apollo';
import {INCIDENT_DURATION_UNIT_PERCENT} from '@constants/variables';

export class EventReportIncidentEditForm extends EventReportIncidentForm {
    componentDidMount() {
        super.componentDidMount();
        this.setUpdateSuccessCallback(() => {
            refetchQueryByName('ReportState');
        });
    }

    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);

        const {GraphQLOptionsData: {incidentDurationUnits}, formValues} = this.props;
        this.handleEditFormLogic(prevProps, formValues, incidentDurationUnits, prevState);
        const entireDurationChanged = formValues.entire_duration !== prevProps.formValues.entire_duration;

        if (incidentDurationUnits !== prevProps.GraphQLOptionsData.incidentDurationUnits && this.props.formParams.duration && entireDurationChanged) {
            this.setIncidentDurationField(incidentDurationUnits, formValues.entire_duration, formValues.incident_duration_unit);
        }
    }

    handleEditFormLogic(prevProps, formValues) {
        if (formValues.incident_duration_unit
            && formValues.incident_duration_unit !== prevProps.formValues.incident_duration_unit) {
            this.setField('incident_duration_unit', {
                defaultValue: formValues.incident_duration_unit,
                timestamp: Date.now(),
            });
            this.setState({incident_duration_unit: formValues.incident_duration_unit});
        }

        const {incident_type, incident_source, report_scopes, incident_duration, incident_duration_unit} = this.props.GraphQLEntityData?.report || {};

        if (incident_type?.id !== prevProps.GraphQLEntityData?.report?.incident_type?.id) {
            this.setField('incident_type', {
                defaultValue: [convertToInt(incident_type.id)],
                timestamp: Date.now(),
            });
        }

        if (incident_source?.id !== prevProps.GraphQLEntityData?.report?.incident_source?.id) {
            this.setField('incident_source', {
                defaultValue: [convertToInt(incident_source.id)],
                timestamp: Date.now(),
            });
        }

        if (report_scopes !== prevProps.GraphQLEntityData?.report?.report_scopes) {
            this.setState({
                existingReportScopes: report_scopes?.map(scope => convertToInt(scope.id)),
            });
        }

        if (incident_duration_unit && incident_duration !== prevProps.GraphQLEntityData?.report?.incident_duration) {
            this.setField('incident_duration', {
                defaultValue: incident_duration_unit.id === INCIDENT_DURATION_UNIT_PERCENT
                    ? convertToInt(incident_duration)
                    : convertSecondsToMinutesWithOneDecimal(incident_duration),
            });
        }
    }

    prepareDataForSubmit(data) {
        const dataToSave = super.prepareDataForSubmit(data);
        dataToSave.id = this.props.formParams.id;

        return dataToSave;
    }
}

export default withRouter(withApollo(EventReportIncidentEditForm));
